import { render } from "./RiUserHeader.vue?vue&type=template&id=3a2f89c5"
import script from "./RiUserHeader.vue?vue&type=script&lang=js"
export * from "./RiUserHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiUserHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a2f89c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a2f89c5', __exports__)) {
    api.reload('3a2f89c5', __exports__)
  }
  
  module.hot.accept("./RiUserHeader.vue?vue&type=template&id=3a2f89c5", () => {
    api.rerender('3a2f89c5', render)
  })

}


export default __exports__